module.exports = {"title":"{name},  allons vous installer dans votre nouveau véhicule !"}